import HeroCarousel from "@/pages/home/components/HeroCarousel";
import SearchBand from "@/pages/home/components/SearchBand";
import CategoryQuickEntry from "@/pages/home/components/CategoryQuickEntry";
import NewsList from "@/pages/home/components/NewsList";
import HotActors from "@/pages/home/components/HotActors";
import IntroBand from "@/pages/home/components/IntroBand";
import { trendingFilms, trendingActors, latestNews } from "@/utils/catalog";
import { useSeo } from "@/hooks/useSeo";

export default function Home() {
  useSeo(
    "葵司-影视资讯与演员资料大全",
    "葵司为您提供全面的影视资讯、演员资料及最新动态，覆盖电影、电视剧、综艺等多种类型，助您轻松查询影视相关信息。",
    "葵司,影视资讯,演员资料,电影,电视剧,综艺,影视动态,影视作品",
  );

  const slides = trendingFilms(5);
  const hotActors = trendingActors(6);
  const news = latestNews(6);

  return (
    <>
      <SearchBand />
      <HeroCarousel slides={slides} />
      <CategoryQuickEntry />
      <NewsList items={news} />
      <HotActors actors={hotActors} />
      <IntroBand />
    </>
  );
}